import React from 'react';

interface BrokenLinkIconProps {
  className?: string;
}

export const BrokenLinkIcon: React.FC<BrokenLinkIconProps> = ({ className }) => {
  return (
    <div
      className={`bg-ds-bg-surface-soft-1 flex items-center justify-center rounded-full w-16 h-16 ${className ?? ''}`}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.4893 13.0017C13.5175 13.0146 12.5492 13.4076 11.8044 14.1827L7.48544 18.6775C5.94943 20.2766 5.94914 22.8858 7.48544 24.4848C9.00015 26.0609 11.4394 26.0608 12.9542 24.4848L13.906 23.4939C14.2887 23.0959 14.9219 23.084 15.3201 23.4665C15.7176 23.8492 15.7298 24.4813 15.3474 24.8793L14.3956 25.8702C12.0938 28.2651 8.34436 28.2654 6.04273 25.8702C3.76302 23.4972 3.76318 19.6651 6.04273 17.292L10.363 12.7973C11.0593 12.0727 11.8883 11.5679 12.7693 11.2816L14.4893 13.0017Z"
          fill="#89959B"
        />
        <path
          d="M12.8123 16.7855C13.2834 16.498 13.8981 16.6467 14.186 17.1176C14.3375 17.3656 14.518 17.6013 14.7263 17.8181C16.0068 19.1505 17.9418 19.3518 19.419 18.4444C19.5225 18.3808 19.6218 18.3083 19.7211 18.2334L21.1456 19.6579C20.9285 19.8389 20.7026 20.0041 20.4672 20.1488C18.1971 21.5437 15.2241 21.2213 13.2849 19.2035C12.9749 18.8809 12.7062 18.5304 12.4802 18.1605C12.1925 17.6894 12.3413 17.0735 12.8123 16.7855Z"
          fill="#89959B"
        />
        <path
          d="M17.6039 6.13058C19.9058 3.73519 23.655 3.73505 25.9568 6.13058C28.2364 8.50374 28.2367 12.3357 25.9568 14.7087L23.5359 17.2264C23.1478 17.6299 22.5041 17.6362 22.1082 17.2404C21.7232 16.8554 21.7171 16.2331 22.0944 15.8406L24.5141 13.3233C26.0504 11.7243 26.0503 9.11509 24.5141 7.516C22.9992 5.93955 20.5602 5.93947 19.0453 7.516L18.0948 8.50689C17.7122 8.90455 17.0789 8.91642 16.6807 8.53423C16.2827 8.15174 16.2699 7.51843 16.6521 7.12017L17.6039 6.13058Z"
          fill="#89959B"
        />
        <path
          d="M16.0805 11.2126C17.0467 11.4824 17.9596 12.0101 18.7159 12.7973C19.0263 13.1201 19.2935 13.4706 19.5193 13.8402C19.6886 14.1176 19.702 14.4431 19.5922 14.7243L16.0805 11.2126Z"
          fill="#89959B"
        />
        <path
          d="M2.66699 2.66669L29.3337 29.3334"
          stroke="#89959B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default BrokenLinkIcon;
